import { Stack } from '@mui/material';

import { FProgressBar } from '../../../../../../components/base';
import { QuestionnaireSectionLabel, QUESTIONNAIRE_PAGE_BOX_SX } from '../../../../common';
import { ChildInfoFields } from '../../../../../common';
import { useIntakeChildBackground, useIntakeChildSchedule } from './hooks';
import { ChildBehaviorIssuesSection } from './components';
import { useIntakeQuestionnaireLoading } from '../../../hooks';
import { FORTA_BLUE } from '../../../../../../utils/colors';

export default function ClientInfoForm() {
  const { backgrounds, hasSavedValues, isSaving, create, remove } = useIntakeChildBackground();
  const {
    schedules,
    notAttendingSchool,
    isSaving: isSavingSchedule,
    create: createSchedule,
    remove: removeSchedule,
  } = useIntakeChildSchedule();
  const isLoading = useIntakeQuestionnaireLoading();

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Child background
      </QuestionnaireSectionLabel>
      <Stack gap={3} textAlign="left" sx={QUESTIONNAIRE_PAGE_BOX_SX}>
        {isSaving ? <FProgressBar /> : null}
        <ChildInfoFields
          backgrounds={backgrounds}
          behaviorIssuesField={<ChildBehaviorIssuesSection />}
          disabled={isLoading || isSaving}
          isSavingSchedule={isSavingSchedule}
          notAttendingSchool={notAttendingSchool}
          onAddSchedule={createSchedule}
          onCreateBackground={create}
          onDeleteBackground={remove}
          onDeleteSchedule={removeSchedule}
          scheduleDisabled={isLoading || isSavingSchedule}
          schedules={schedules}
          showListErrors={!isLoading && hasSavedValues}
          showScheduleErrors={!isLoading}
        />
      </Stack>
    </>
  );
}
